module.exports = __webpack_public_path__ + "static/app/img/service1.d240f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/service1.jpg
// module id = dwPR
// module chunks = 1